import { isAdminUser } from '../feature-flags/is-admin-user';

/**
 * Pure permission check for module-level access. Can be called in any
 * context (loops, memos, render) as long as `hasAllPermissions` is provided.
 *
 * AND semantics: ALL specified permissions must be satisfied.
 * - No permissions or empty array → accessible
 * - Contains 'admin' → requires `isAdminUser()`
 * - Non-admin strings → checked via `hasAllPermissions` (JWT claims)
 *
 * Example: `['admin', 'view-reports']` requires the user to be both an
 * admin AND have the 'view-reports' JWT claim.
 */
export const checkModulePermissions = (
  permissions: string[] | undefined,
  hasAllPermissions: (scopes: string[]) => boolean,
): boolean => {
  if (!permissions || permissions.length === 0) return true;
  if (permissions.includes('admin') && !isAdminUser()) return false;

  const nonAdminPermissions = permissions.filter((p) => p !== 'admin');
  if (
    nonAdminPermissions.length > 0 &&
    !hasAllPermissions(nonAdminPermissions)
  ) {
    return false;
  }

  return true;
};
